import React, { useState } from 'react';

const CalculatorWindow = () => {
    const [maßnahme, setMaßnahme] = useState('Fenster');
    const [kosten, setKosten] = useState('');
    const [wohneinheiten, setWohneinheiten] = useState(1);
    const [alter, setAlter] = useState(0);
    const [isfp, setIsfp] = useState(0);
    const [foerderbetrag, setFoerderbetrag] = useState(null);
    const [error, setError] = useState('');

    const handleCalculate = () => {
        const kostenVal = parseFloat(kosten);
        if (isNaN(kostenVal) || kostenVal <= 0) {
            setError('Bitte geben Sie eine gültige Summe ein.');
            setFoerderbetrag(null);
            return;
        }

        if (parseInt(alter) === 0) {
            setError('Keine Förderung möglich, da die Immobilie nicht älter als 5 Jahre ist.');
            setFoerderbetrag(null);
            return;
        }

        const foerdersaetze = {
            "Fenster": 15,
            "Dämmung": 15,
            "Türen": 15,
            "Dachdämmung": 15,
            "Kellerdämmung": 15,
            "Smart Home": 15,
            "Heizungsoptimierung": 15,
            "Lüftungsanlage": 15,
            "Sommerlicher Wärmeschutz": 15,
            "Einrichtung und Erweiterung": 25,
            "Gebäudenetzanschluss": 25,
            "Photovoltaik": 0,
            "Fachplanung": 50
        };

        let foerdersatz = foerdersaetze[maßnahme] || 0;
        foerdersatz += parseFloat(isfp);

        const maxFoerderfaehigeSumme = wohneinheiten * (isfp > 0 ? 60000 : 30000);
        const foerderfaehigeKosten = Math.min(kostenVal, maxFoerderfaehigeSumme);
        const foerderbetragValue = (foerderfaehigeKosten * foerdersatz) / 100;

        setFoerderbetrag(foerderbetragValue);
        setError('');
    };

    return (
        <div className="w-full flex justify-center py-6 px-4 sm:px-8 md:px-16">
            <div className="w-full lg:w-3/4 bg-white px-4 sm:px-6 lg:px-8 py-8 sm:py-10 rounded-2xl border bg-secondary-light shadow-lg">
                <h3 className="text-2xl sm:text-3xl lg:text-4xl text-primary font-bold mb-4 text-center">
                    Förderrechner für Einzelmaßnahmen
                </h3>

                <div className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-secondary-dark mb-2">Wählen Sie die geplante Maßnahme:</label>
                        <select
                            value={maßnahme}
                            onChange={(e) => setMaßnahme(e.target.value)}
                            className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-primary focus:border-primary"
                        >
                            {/* Add all options */}
                            {[
                                "Fenster", "Dämmung", "Türen", "Dachdämmung", "Kellerdämmung", "Smart Home",
                                "Heizungsoptimierung", "Lüftungsanlage", "Sommerlicher Wärmeschutz", "Einrichtung und Erweiterung",
                                "Gebäudenetzanschluss", "Photovoltaik", "Fachplanung"
                            ].map(option => <option key={option} value={option}>{option}</option>)}
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-secondary-dark mb-2">Kosten der Maßnahme (€):</label>
                        <input
                            type="number"
                            value={kosten}
                            onChange={(e) => setKosten(e.target.value)}
                            className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-primary focus:border-primary"
                            placeholder="Geben Sie die Kosten ein"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-secondary-dark mb-2">Anzahl der Wohneinheiten:</label>
                        <select
                            value={wohneinheiten}
                            onChange={(e) => setWohneinheiten(e.target.value)}
                            className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-primary focus:border-primary"
                        >
                            {[...Array(10).keys()].map(i => <option key={i} value={i + 1}>{i + 1}</option>)}
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-secondary-dark mb-2">Alter der Immobilie:</label>
                        <select
    value={alter}
    onChange={(e) => setAlter(Number(e.target.value))}
    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-primary focus:border-primary"
>

                            <option value="1">Älter als 5 Jahre</option>
                            <option value="0">Nicht älter als 5 Jahre (keine Förderung)</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-secondary-dark mb-2">Sanierungsfahrplan vorhanden?</label>
                        <select
                            value={isfp}
                            onChange={(e) => setIsfp(e.target.value)}
                            className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-primary focus:border-primary"
                        >
                            <option value="0">Kein Sanierungsfahrplan vorhanden</option>
                            <option value="5">Sanierungsfahrplan bereits vorhanden (+5% Förderung)</option>
                        </select>
                    </div>

                    <button
                        onClick={handleCalculate}
                        className="w-full p-3 bg-primary text-white rounded-xl mt-6 hover:bg-primary-dark focus:outline-none"
                    >
                        Förderung berechnen
                    </button>

                    {error && <p className="text-red-500 text-sm mt-2 text-center">{error}</p>}

                    {foerderbetrag !== null && !error && (
                        <div className="w-full mt-6 p-6 bg-primary/10 rounded-xl border border-primary/20 text-center">
                            <div className="text-lg font-semibold text-secondary-dark">Ihr Förderbetrag beträgt:</div>
                            <div className="text-2xl font-bold text-primary">{foerderbetrag.toFixed(2)} €</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CalculatorWindow;
